require('../../../vendor/assets/javascripts/v2/jquery-ui-1.10.4.custom')


window.v3RegistrationApp = angular.module("cerego.v3Registration", [
  "ngRoute"
  "cerego.common"
  "cerego.layout"
  "ngPromiseExtras"
]).config(['$routeProvider', ($routeProvider) ->
  $routeProvider
  .when Packs.iKnowRoutes.v3_join_course_path(":partner_id", ":course_id"),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("course_sign_up")
    controller  : 'courseRegistrationCtrl'
    resolve:
      $signInSuccessPath: ['$location', ($location) -> $location.path()]
      $signUpPath: ['$location', ($location) -> $location.path()]
      $toggleAction: -> "signin"
  .when Packs.iKnowRoutes.v3_course_invite_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("course_sign_up")
    controller  : 'courseRegistrationCtrl'
  .when Packs.iKnowRoutes.v3_signin_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("sign_in")
    controller  : 'signInCtrl'
    resolve:
      $toggleAction: -> "signup"
  .when Packs.iKnowRoutes.edit_v3_password_path(":token"),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("reset_password")
    controller  : 'resetPasswordCtrl'
    resolve:
      $toggleAction: -> "signin"
  .when Packs.iKnowRoutes.new_v3_password_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("forgot_password")
    controller  : 'resetPasswordCtrl'
    resolve:
      $toggleAction: -> "signin"
  .when Packs.iKnowRoutes.v3_native_app_launcher_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("native_app_launcher"),
    controller  : 'nativeAppLauncherCtrl'
    controllerAs : 'ctrl'
    resolve:
      $headerTheme: -> 'hidden'
  .when Packs.iKnowRoutes.callback_v3_oauth_path(":id"),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("oauth_redirect_progress")
    controller  : 'OAuthCallbackCtrl'
  .when Packs.iKnowRoutes.v3_add_contributor_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("invitation")
    controller  : 'invitationCtrl'
    resolve:
      $tokenKey: -> "editor_invitation"
  .when Packs.iKnowRoutes.v3_partners_registrations_new_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("invitation")
    controller  : 'invitationCtrl'
    resolve:
      $tokenKey: -> "partner_invitation"
  .when Packs.iKnowRoutes.v3_signout_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("signout_progress")
    controller  : 'signOutCtrl'
  .when Packs.iKnowRoutes.v3_email_confirmation_path(":id"),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("confirm_email")
    controller  : 'confirmEmailCtrl'
  .when Packs.iKnowRoutes.v3_temp_login_path(),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("temp_login")
    controller  : 'tempLoginCtrl'
  .when Packs.iKnowRoutes.v3_merge_request_path(":id"),
    templateUrl : Packs.iKnowRoutes.registrations_v3_templates_path("account_merge")
    controller  : 'accountMergeCtrl'
  .otherwise
    template : "<div></div>"
    controller: ['$window', ($window) ->
      $window.location.href = Packs.iKnowRoutes.ceregoMainLearnApp()
    ]
]).config(['$compileProvider', ($compileProvider) ->
  # needed to whitelist ceregonativeapp:// links
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|local|data|ceregonativeapp):/)
])

# require this via webpack later
# "v2/modules/cerego-layout-app" remove from v3/_head
# "v3/modules/common"

req = require.context('../../assets/javascripts/v3/modules/registrations/resources', false)
req.keys().forEach(req)

req = require.context('../../assets/javascripts/v3/modules/registrations/controllers', false)
req.keys().forEach(req)
